import { createSelector } from '@ngrx/store';
import { ProjectResponseGetById } from '@nx-customer-apps/api-planning-projects';
import { AppState, ProjectState } from '@nx-customer-apps/shared/interfaces';
import { ProductType } from '@nx-customer-apps/components';
import { ProjectUtils } from '@nx-customer-apps/shared/utils';

export namespace ProjectSelectors {
    const projectState = (state: AppState) => state.project;

    export const getState = () => createSelector(projectState, (state: ProjectState) => state);

    export const selectProject = () => createSelector(projectState, (state: ProjectState) => state?.selectedProject);

    export const selectSelectedVariantId = () =>
        createSelector(projectState, (state: ProjectState) => {
            return state?.selectedProject ? ProjectUtils.getSelectedVariant(state?.selectedProject)?.id : null;
        });

    export const selectAddressCollision = () => createSelector(projectState, (state: ProjectState) => state?.addressCollision);

    export const selectHasSystemComponentsOrHeatloads = () =>
        createSelector(projectState, (state: ProjectState) => {
            const project = state.selectedProject as ProjectResponseGetById;
            const plannings = ProjectUtils.getPlanningsWithProductsFromVariants(project);
            const products = plannings
                ?.map(planning => planning?.products?.filter(product => product.productType !== ProductType.Other))
                .flat(1);
            return products?.length! > 0 || project?.building?.heatLoadCalculations?.length! > 0;
        });

    export const selectAddress = () =>
        createSelector(projectState, (state: ProjectState) => {
            const project = state.selectedProject;
            return {
                city: project?.address.city,
                countryCode: project?.address.countryCode,
                houseNumber: project?.address.houseNumber,
                postalCode: project?.address.postalCode,
                streetName: project?.address.streetName
            };
        });
}
